export default function roundRobinPick<T>(arrayOfArrayOfItems: T[][], targetNumberOfItems: number): T[][] {
    const sumLengths = (a2: T[][]) => a2.reduce((a, c) => a + c.length, 0)
    const advance = (x: number, limit: number) => { x += 1; if (x >= limit) x = 0; return x; }
    const numberOfGroups = arrayOfArrayOfItems.length
    const result: T[][] = [...(new Array(numberOfGroups))].map(_ => [])
    let groupIndex = -1
    while (sumLengths(result) < targetNumberOfItems && sumLengths(arrayOfArrayOfItems) > 0) {
        groupIndex = advance(groupIndex, numberOfGroups)
        const current = arrayOfArrayOfItems[groupIndex].shift()
        if (!current) continue
        result[groupIndex].push(current)
    }
    return result
}
